<template>
    <div class="download_button" @click="openModal('DownloadContents')">
        <svg xmlns="http://www.w3.org/2000/svg" width="13.66" height="12.816" viewBox="0 0 13.66 12.816"><g transform="translate(123.606 211.725)"><path d="M83.182-205.99a.827.827,0,0,1,.042-1.169.827.827,0,0,1,1.169.042l1.972,2.112V-210.9a.829.829,0,0,1,.829-.829.829.829,0,0,1,.829.829v5.891L90-207.117a.827.827,0,0,1,1.169-.042.827.827,0,0,1,.042,1.169q-1.7,1.824-3.407,3.649-.02.022-.042.042a.827.827,0,0,1-1.169-.042l-3.407-3.649Z" transform="translate(-203.971)"/><path d="M-111.6,427.5a.829.829,0,0,1,.829-.829.829.829,0,0,1,.829.829v1.809a2.16,2.16,0,0,1-2.156,2.156h-9.348a2.16,2.16,0,0,1-2.156-2.156V427.5a.829.829,0,0,1,.829-.829.829.829,0,0,1,.829.829v1.809a.5.5,0,0,0,.5.5h9.348a.5.5,0,0,0,.5-.5V427.5Z" transform="translate(0 -630.379)"/></g></svg>
        画像ダウンロード
    </div>
</template>

<script>
    export default {
        name: "DownloadButton",
        methods: {
            openModal(){
                const dl_modal = document.getElementById('dl_modal');
                dl_modal.classList.add ('open');
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

.download_button{
            @extend .clickable;
            user-select: none;
            display: flex;
            align-items: center;
            text-align: center;
            padding: 5px 10px;
            font-size: clamp(10px, 1vw, 18px);
            border: 1px solid #040404;
            border-radius: 3px;
            transition: 0.3s;
            > *:not(:last-child) { margin-right: 0.25rem }
        svg{
            margin-right: 5px;
            transition: 0.3s;
            height: auto;
            width: 1em;
        }
    }
    .download_button:hover,
    .download_button.selected{
        background-color: #040404;
        color: #fff;
        svg{
             fill: #fff;
        }
    }

    @media (max-width: 739px) {
        .download_button{
            padding: 0px 10px;
        }
    }

</style>
